import api from './api';
import { Newspaper, PaginatedResponse } from '../types';

interface NewspaperFilters {
  search?: string;
  year?: number;
  page?: number;
  limit?: number;
}

export const newspapersService = {
  async getList(filters: NewspaperFilters = {}): Promise<PaginatedResponse<Newspaper>> {
    const params = new URLSearchParams();
    
    if (filters.search) params.append('search', filters.search);
    if (filters.year) params.append('year', filters.year.toString());
    if (filters.page) params.append('page', filters.page.toString());
    if (filters.limit) params.append('limit', filters.limit.toString());
    
    const response = await api.get<PaginatedResponse<Newspaper>>('/newspapers', { params });
    return response.data;
  },

  async getById(id: number): Promise<Newspaper> {
    const response = await api.get<Newspaper>(`/newspapers/${id}`);
    return response.data;
  },

  async create(data: Omit<Newspaper, 'id' | 'createdAt' | 'updatedAt'>): Promise<Newspaper> {
    const response = await api.post<Newspaper>('/newspapers', data);
    return response.data;
  },

  async update(id: number, data: Partial<Newspaper>): Promise<Newspaper> {
    const response = await api.put<Newspaper>(`/newspapers/${id}`, data);
    return response.data;
  },

  async delete(id: number): Promise<void> {
    await api.delete(`/newspapers/${id}`);
  },
};

export default newspapersService;